import React from "react";
import { Container } from "vComponents";

function CartSummary({ style, price, couponAmount, plan, ...props }) {
  return (
    <Container style={style}>
      <h3>Cart Summary</h3>
      <div
        style={{
          height: "100px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            margin: "10px 0px",
          }}
        >
          <p>
            {plan.title}{" "}
            {plan.subheader && plan.price === "29.99"
              ? "(" + plan.subheader + ")"
              : null}
            {plan.subheader && plan.title === "Annual" ? "($29.99/mo)" : null}
          </p>
          <p>${plan.price}</p>
        </div>
        {/* <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            margin: "10px 0px",
          }}
        >
          <p>Promotion</p>
          <p>{`-$50.00`}</p>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            margin: "10px 0px",
          }}
        >
          <p>First Month Free</p>
          <p>{`-$49.99`}</p>
        </div> */}
        {/* {!!couponAmount && <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            margin: '10px 0px'
          }}        
        >
          <p>Coupon</p>
          <p>{`-$${couponAmount}`}</p>
        </div>} */}
      </div>
      {/* <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          margin: "10px 0px",
        }}
      >
        <p>Tax</p>
        <p>{`$0.00`}</p>
      </div> */}
      <hr
        style={{
          border: "1px solid #89D2D3",
          margin: "15px 0px",
        }}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          margin: "10px 0px",
        }}
      >
        <p>Today's Total</p>
        <p>${plan.price}</p>
      </div>
      <p
        style={{
          fontSize: "13px",
        }}
      >
        At the end of each billing cycle, we will charge you according to your
        current plan level. You may cancel at any time.
      </p>
    </Container>
  );
}

CartSummary.defaultProps = {
  price: "0.00",
};

export default CartSummary;
